import React from 'react'

export default function FooterCredit() {
    return (
        <div className={"footer-credit"}>
            &copy; Southern Partners | 2020
        </div>
    )
}
